import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
import { Focusable } from '../Focusable';
export function SubjectCard({ isSelected, subjectName, tutorName, grade, onPress, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: [
            styles.subjectWrapper,
            isSelected ? styles.subjectSelected : {},
            style
        ], key: subjectName, onPress: () => {
            if (onPress)
                onPress(subjectName);
        } },
        React.createElement(Text, { type: 'headline', size: 'lg', style: isSelected ? styles.selectedText : {} }, subjectName),
        React.createElement(View, { style: styles.tutorInfoRow },
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.subText }, `Tutor `),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'semibold', style: styles.subText }, `${tutorName} · `),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.subText }, grade))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    subjectWrapper: {
        padding: size.G,
        backgroundColor: color.invert2.p4,
        borderRadius: size.H,
        marginBottom: size.C,
        marginRight: size.C,
        minWidth: 300,
        borderWidth: 2,
        borderColor: 'transparent'
    },
    subjectSelected: {
        borderColor: color.primary.solid,
        backgroundColor: color.primary.ghost
    },
    selectedText: { color: color.primary.solid },
    tutorInfoRow: { flexDirection: 'row', marginTop: size.C },
    subText: { color: color.invert2.p56 }
}));
//# sourceMappingURL=index.js.map